import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    FormControlLabel,
    Checkbox,
} from '@mui/material';
import CommonButton from '../components/atom/CommonButton';
import { useTranslation } from 'react-i18next';

const CheckinFinishModal = ({
    title,
    confirm,
    showModal,
    MODAL_TYPE,
    initialNote = '',
    initialSuppressReviewEmail = false,
}) => {
    const { t } = useTranslation();
    const [input, setInput] = useState(initialNote);
    const [suppressReviewEmail, setSuppressReviewEmail] = useState(initialSuppressReviewEmail);

    const closeAction = () => showModal(MODAL_TYPE.NONE);

    return (
        <Dialog
            open
            onClose={closeAction}
            aria-labelledby="checkin-finish-title"
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle id="checkin-finish-title">{title}</DialogTitle>
            <DialogContent>
                <TextField
                    label={t('checkinview.finishNote')}
                    value={input}
                    onChange={(e) => setInput(e.target.value)}
                    fullWidth
                    margin="normal"
                />
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={suppressReviewEmail}
                            onChange={(e) => setSuppressReviewEmail(e.target.checked)}
                        />
                    }
                    label={t('checkinview.suppressReviewEmail')}
                />
            </DialogContent>
            <DialogActions>
                <CommonButton
                    onClick={closeAction}
                    label={t('common.close')}
                    buttonType="secondary"
                />
                <CommonButton
                    onClick={() => {
                        confirm(input.trim(), suppressReviewEmail);
                        showModal(MODAL_TYPE.NONE);
                    }}
                    label={t('checkinview.finishButton')}
                    buttonType="primary"
                />
            </DialogActions>
        </Dialog>
    );
};

export default CheckinFinishModal;
